import { useEffect, useRef, useState } from "react";
import { colors } from "../../data/colors";
import CloseIcon from "@mui/icons-material/Close";
import { stdObject } from "../../data/types/stdObject";
import { useTranslation } from "react-i18next";
import useScreenSize from "../../utils/getDimentions";
import {
  alignList,
  emptys,
  fontsOptions,
  maxMobileSize,
  vAlignList,
} from "../../data/main";
import convertDate from "../../utils/convertDate";
import { convertAge } from "../../utils/convertAge";
import { ageToString } from "../../utils/ageToString";
import { sexesOptions } from "../../screens/MainStructure/SearchBar/data/searchItemUtils";
import { useReactToPrint } from "react-to-print";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useMainContext } from "../../context/MainContext";
import {
  branchCodes,
  docExclude,
  linesExclude,
  personExclude,
} from "../../data/stationery";
import { getPrefix } from "../../utils/getPrefix";
import { createTable } from "./components/createTable";
import { stationeryObjectCodes } from "./variables/stationeryObjectCodes";
import { saveStationery } from "../../screens/MainFrame/functions/stationery/saveStationery";
import { closeStationery } from "../../screens/MainFrame/functions/stationery/closeStationery";
import { createNewPart } from "../../screens/MainFrame/functions/stationery/createNewPart";
import { sendData } from "../../services/sendData";
import { getCurrentDate } from "../../utils/getCurrentDate";
import { deleteStationery } from "../../screens/MainFrame/functions/stationery/deleteStationery";

export default function useStationeryModal({
  open = false,
  info,
}: {
  open: boolean;
  info: stdObject;
}) {
  const { t } = useTranslation();
  const pricesRates: any = useSelector((state: RootState) => state.data.tar);
  const cPayments: any = useSelector((state: RootState) => state.data.ctpa);
  const vPayments: any = useSelector((state: RootState) => state.data.vtpa);
  const {
    type = "",
    mainColor = colors.settings,
    area = "v",
    documentData = {},
    tickets,
    branch = {},
    personData = {},
    paymentsData = {},
    lines = [],
    formats = [],
    partsList = [],
    data = {},
    parts = [],
    doc = [],
    rows = [],
    person = [],
    payments = [],
    prices = [],
    formCode = 0,
    formValues = [],
  } = info;
  const {
    customUpdate,
    docValues,
    closeMsg,
    setMsg3,
    setModalData3,
    setDocValues,
    setStationeryModal,
    setMsg,
    documentAction,
    openWindow,
    logoutAction,
  } = useMainContext();
  const screenSize = useScreenSize();
  const user: any = useSelector((state: RootState) => state.data.user);
  const sucsList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.suc,
  );
  const [paperData, setPaperData] = useState<stdObject>({
    index: 0,
    data,
    parts,
  });
  const [headerInfo, setHeaderInfo] = useState<Array<stdObject>>([]);
  const [showScreen, setShowScreen] = useState<boolean>(!(info.code === "new"));
  const [actives, setActives] = useState<stdObject>({});
  const [inputsValues, setInputsValues] = useState<stdObject>({});
  const [minModalWidth, setMinModalWidth] = useState<boolean>(false);
  const pageDiv = useRef<HTMLInputElement>(null);
  const deskDiv = useRef<HTMLInputElement>(null);
  const formId = useRef(info.formId);
  const [tabIndex, setTabIndex] = useState(0);
  const [scaleInfo, setScaleInfo] = useState(1);
  const [pages, setPages] = useState<stdObject[]>([]);
  const [ticketsList, setTicketsList] = useState<stdObject[]>([]);
  const [selected, setSelected] = useState<stdObject>({
    index: -1,
    num: 0,
    values: {},
  });
  const [flexDir, setFlexDir] = useState<[boolean, boolean]>([false, false]);

  const squareButtons = [
    {
      Icon: CloseIcon,
      onClick: () =>
        closeStationery(false, {
          docValues,
          setDocValues,
          setStationeryModal,
          setMsg,
          documentAction,
          openWindow,
          closeMsg,
        }),
      color: colors.red,
    },
  ];
  const switchTab = (index: number) => setTabIndex(index);

  const hiddenDiv = useRef<HTMLDivElement>(null);
  const recordsRef = useRef<HTMLDivElement>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const printArea = useRef<HTMLInputElement | null>(null);
  const reactToPrintFn = useReactToPrint({ contentRef: recordsRef } as any);
  const isDoc = paperData.data.TIPDOC !== "ART";

  const handlePrint = useReactToPrint({ contentRef: printArea });
  const alignOptions = alignList.map((e: stdObject) => {
    return {
      label: t(e.ALINOM),
      value: e.ALICAB,
    };
  });

  const vAlignOptions = vAlignList.map((e: stdObject) => {
    return {
      label: t(e.VALNOM),
      value: e.VALCAB,
    };
  });

  const editValues = [
    isDoc && {
      code: "PAGPAR",
      type: "select",
      options: [
        { label: t("p.always"), value: 0 },
        { label: t("p.atTheBeginning"), value: 1 },
        { label: t("p.inTheEnd"), value: 2 },
      ],
    },
    {
      code: "TIPPAR",
      type: "select",
      options: stationeryObjectCodes
        .filter((e: stdObject) => isDoc || (!isDoc && !e.type))
        .map(({ label, value }: stdObject) => {
          return {
            label: t(`p.${label}`),
            value,
          };
        }),
    },
    { code: "PREPAR", type: "text" },
    { code: "TXTPAR", type: "text" },
    { code: "SUFPAR", type: "text" },
    { code: "IMGPAR", type: "button" },
    { code: "XPAR", type: "number", suffix: "px", innerStyle: { width: 60 } },
    { code: "YPAR", type: "number", suffix: "px", innerStyle: { width: 60 } },
    { code: "ANCPAR", type: "number", suffix: "px", innerStyle: { width: 60 } },
    { code: "ALTPAR", type: "number", suffix: "px", innerStyle: { width: 60 } },
    { code: "BORPAR", type: "number", innerStyle: { width: 40 } },
    { code: "CBOPAR", type: "color", innerStyle: { width: 60 } },
    { code: "REDPAR", type: "number", innerStyle: { width: 40 } },
    { code: "PADPAR", type: "number", suffix: "px", innerStyle: { width: 40 } },
    { code: "SIZPAR", type: "number", suffix: "px", innerStyle: { width: 40 } },
    {
      code: "FONPAR",
      type: "select",
      options: fontsOptions,
    },
    {
      code: "ALIPAR",
      type: "select",
      options: alignOptions,
    },
    {
      code: "VALPAR",
      type: "select",
      options: vAlignOptions,
    },
    { code: "BOLPAR", type: "checkbox" },
    { code: "ITAPAR", type: "checkbox" },
    { code: "ANGPAR", type: "number", suffix: "°", innerStyle: { width: 60 } },
    { code: "COLPAR", type: "color", innerStyle: { width: 60 } },
    { code: "CFOPAR", type: "color", innerStyle: { width: 60 } },
    { code: "TRAPAR", type: "number", innerStyle: { width: 40 } },
    { code: "GRAPAR", type: "number", innerStyle: { width: 40 } },
    { code: "PROPAR", type: "checkbox" },
    { code: "NIVPAR", type: "number", innerStyle: { width: 40 } },
  ];

  const hasTicket = Array.isArray(tickets);

  const isPrint =
    Array.isArray(tickets) || Object.keys(documentData).length > 0;

  const askDeleteStationery = () => {
    setMsg3("custom3");
    setModalData3({
      label: t("p.askDeleteStationery"),
      buttons: [
        {
          label: t("p.delete"),
          onClick: () =>
            deleteStationery(data.CODDOC, {
              t,
              customUpdate,
              docValues,
              closeMsg,
              setMsg3,
              setDocValues,
              setStationeryModal,
              setMsg,
              documentAction,
              openWindow,
              logoutAction,
            }),
          color: colors.red,
        },
        {
          label: t("p.cancel"),
          onClick: () => closeMsg(3),
          color: colors.darkGrey,
        },
      ],
    });
  };

  const saveForm = async () => {
    setMsg3("loading");
    const payloadSaveForm = {
      formCode,
      formId: formId.current ?? 0,
      values: Object.entries(inputsValues).reduce(
        (acc: stdObject, curr: [string, any]) => {
          return typeof curr[1] === "string" && curr[1].trim() !== ""
            ? {
                ...acc,
                [curr[0]]: curr[1].trim(),
              }
            : acc;
        },
        {},
      ),
      type,
      doc: type,
      serie: documentData[`SER${type}`],
      code: documentData[`COD${type}`],
      name: data.NOMDOC,
      date: getCurrentDate(true),
    };
    console.log("payloadSaveForm", payloadSaveForm);

    const responseSaveForm: stdObject = await sendData({
      endPoint: "saveForm",
      payload: payloadSaveForm,
      logoutAction,
    });
    console.log("responseSaveForm", responseSaveForm);

    if (responseSaveForm.success && responseSaveForm.status) {
      if (!docValues.formId) {
        setDocValues({ ...docValues, formId: responseSaveForm.formId });
      }
      formId.current = responseSaveForm.formId;
      closeMsg(3);
      return true;
    } else {
      setMsg3("error");
    }
    return false;
  };

  const startPrint = async () => {
    if (
      !showScreen &&
      (formCode === 0 || (formCode > 0 && (await saveForm())))
    ) {
      if (scaleInfo !== 1) setScaleInfo(1);
      setTimeout(handlePrint, 0);
    }
  };

  const printData = {
    1: branch,
    2: documentData,
    3: personData,
    5: paymentsData,
  };

  const tabs = isPrint
    ? []
    : [
        { label: t("p.general") },
        { label: t("c.SUC") },
        { label: isDoc ? t("p.document") : t("c.ART") },
        isDoc && { label: t("p.body") },
        { label: t("p.objects") },
      ];

  let buttons = isPrint
    ? [
        {
          label: t("p.print"),
          onClick: startPrint,
          color: showScreen ? colors.grey : colors.blue,
        },
        formCode > 0
          ? {
              label: t("p.save"),
              onClick: saveForm,
              color: colors.green,
            }
          : {},
      ]
    : [
        {
          label: t("p.delete"),
          onClick: askDeleteStationery,
          color: colors.red,
        },
        {
          label: t("p.save"),
          onClick: () =>
            saveStationery(actives, {
              t,
              customUpdate,
              docValues,
              closeMsg,
              setMsg3,
              setModalData3,
              setDocValues,
              setStationeryModal,
              setMsg,
              documentAction,
              openWindow,
              logoutAction,
            }),
          color: colors.green,
        },
        {
          label: t("p.close"),
          onClick: () =>
            closeStationery(false, {
              docValues,
              setDocValues,
              setStationeryModal,
              setMsg,
              documentAction,
              openWindow,
              closeMsg,
            }),
        },
      ];

  if (!isPrint && info.code === "new") {
    buttons.shift();
  }
  const brandsOptions = [
    { label: t("p.allBranches"), value: 0 },
    ...sucsList.map((e) => {
      return { label: e.NOMSUC, value: e.CODSUC };
    }),
  ];

  const printOptions = [
    [
      {
        code: "FORDOC",
        type: "select",
        style: { marginTop: 5, paddingLeft: 5 },
        options: formats.map((e: stdObject, index: number) => {
          return { label: e.NOMDOC, value: index };
        }),
        onChange: (index: number) => {
          setPaperData({
            index,
            data: formats[index],
            parts: partsList[index],
          });
          recountPages(index);
        },
      },
      // { code: "COPDOC", type: "number", innerStyle: { width: 60 } },
    ],
  ];

  const listItems: stdObject = {
    0: [
      { code: "NOMDOC", type: "text" },
      { code: "SUCDOC", type: "select", options: brandsOptions },
      isDoc && { code: "FOMDOC", type: "checkbox" },
      { code: "ANCDOC" },
      { code: "ALTDOC" },
      isDoc && { code: "CABDOC" },
      {
        code: "ANGDOC",
        type: "select",
        options: [
          { label: "0°", value: 0 },
          { label: "90°", value: 90 },
        ],
      },
      { code: "OBSDOC", type: "text" },
      isDoc && {
        label: t("p.body"),
        type: "label",
        style: { backgroundColor: colors.settings },
      },
      isDoc && { code: "ADSDOC", type: "checkbox" },
      isDoc && { code: "TALDOC" },
      isDoc && { code: "TANDOC" },
      isDoc && { code: "CFODOC", type: "color", innerStyle: { width: 60 } },
      isDoc && {
        code: "PADDOC",
        type: "number",
        suffix: "px",
        innerStyle: { width: 60 },
      },
      isDoc && {
        code: "SIZDOC",
        type: "number",
        suffix: "px",
        innerStyle: { width: 60 },
      },
      isDoc && { code: "COLDOC", type: "color", innerStyle: { width: 60 } },
      isDoc && {
        code: "FONDOC",
        type: "select",
        options: fontsOptions,
      },
      isDoc && {
        code: "ALIDOC",
        type: "select",
        options: alignOptions,
      },
      isDoc && {
        code: "ATADOC",
        type: "select",
        options: alignOptions,
      },
      isDoc && { code: "BOLDOC", type: "checkbox" },
      isDoc && { code: "ITADOC", type: "checkbox" },
      isDoc && { code: "HOBDOC", type: "checkbox" },
      isDoc && { code: "HSNDOC", type: "checkbox" },
      isDoc && {
        code: "TPADOC",
        type: "number",
        suffix: "px",
        innerStyle: { width: 60 },
      },
      {
        label: t("p.printing"),
        type: "label",
        style: { backgroundColor: colors.settings },
      },
      { code: "COPDOC", type: "number", innerStyle: { width: 60 } },
      { code: "PRIDOC", type: "text" },
      { code: "PRI2DOC", type: "text" },
    ],
    1: branchCodes.map((e: string) => {
      return { code: e, label: t(`s.${e}`), partType: 1 };
    }),
    2: [
      isDoc && {
        code: "FORMNUMBER",
        label: t(`s.FORMNUMBER`),
        partType: 2,
      },
      ...doc
        .filter((e: string) => !docExclude.some((v: string) => e.startsWith(v)))
        .map((e: string) => {
          return { code: e, label: t(`c.${getPrefix(e)}`), partType: 2 };
        }),
      !isDoc && {
        label: t("p.prices"),
        type: "label",
        style: { backgroundColor: colors.settings },
      },
      ...prices.map((e: stdObject) => {
        return (
          !isDoc && { code: String(e.CODTAR), label: t(e.NOMTAR), partType: 13 }
        );
      }),
      isDoc && { code: "DATEONLY", label: t(`s.DATEONLY`), partType: 2 },
      isDoc && { code: "HOUR", label: t(`s.HOUR`), partType: 2 },
      isDoc && { code: "CURRPAGE", label: t(`s.CURRPAGE`), partType: 2 },
      isDoc && { code: "QTYPAGES", label: t(`s.QTYPAGES`), partType: 2 },
      isDoc && {
        label:
          area === "c"
            ? t("p.supplierData", { supplier: t("p.supplier") })
            : t("p.customerData", { customer: t("p.customer") }),
        type: "label",
        style: { backgroundColor: colors.settings },
      },
      ...person
        .filter(
          (e: string) =>
            isDoc && !personExclude.some((v: string) => e.startsWith(v)),
        )
        .map((e: string) => {
          return { code: e, label: t(`c.${getPrefix(e)}`), partType: 3 };
        }),
      isDoc && {
        label: t("p.payments"),
        type: "label",
        style: { backgroundColor: colors.settings },
      },
      ...payments.map((e: stdObject) => {
        return (
          isDoc && { code: String(e.CODTPA), label: e.NOMTPA, partType: 5 }
        );
      }),
    ],
    3: rows
      .filter((e: string) => !linesExclude.some((v: string) => e.startsWith(v)))
      .map((e: string) => {
        return {
          code: e,
          label:
            getPrefix(e) === "PRE"
              ? t("p.price")
              : getPrefix(e) === "NOM"
                ? t("c.DES")
                : t(`c.${getPrefix(e)}`),
          partType: 4,
        };
      }),
    4: paperData.parts
      .filter((e: stdObject) =>
        stationeryObjectCodes
          .map(({ value }) => {
            return value;
          })
          .includes(e.TIPPAR),
      )
      .map((e: stdObject) => {
        return {
          code: e.NUMPAR,
          label: e.TXTPAR,
          partType: e.TIPPAR,
          Icon: stationeryObjectCodes.find(({ value }) => value === e.TIPPAR)
            ?.Icon,
        };
      }),
  };

  useEffect(() => {
    if (open) {
      if (minModalWidth && screenSize.width > maxMobileSize) {
        setMinModalWidth(false);
      }
      if (!minModalWidth && screenSize.width <= maxMobileSize) {
        setMinModalWidth(true);
      }
    }
  }, [screenSize]);

  const getValue = (code: string, value: string | number | undefined) => {
    switch (code) {
      case "NAC":
        return convertDate({ info: value as string, time: false, t });
      case "TIM":
        let newAge = typeof value === "string" ? convertAge(value) : "";
        return Array.isArray(newAge) ? ageToString(newAge, t) : "";
      case "GEN":
        let newValue =
          typeof value === "number"
            ? sexesOptions.find((e) => e.value === value.toString())?.label
            : "";
        return typeof newValue === "string" ? t(newValue) : "";
      default:
        return value;
    }
  };

  useEffect(() => {
    if (headerInfo.length > 0) {
      reactToPrintFn();
      setHeaderInfo([]);
    }
  }, [headerInfo]);

  const resizeZoom = (zoom: boolean) => {
    setScaleInfo(zoom ? scaleInfo + 0.1 : scaleInfo - 0.1);
  };

  const resizePage = () => {
    if (!pageDiv.current || !deskDiv.current) return;
    const rect = pageDiv.current.getBoundingClientRect();
    setFlexDir([
      rect.width > deskDiv.current.offsetWidth,
      rect.height * (isPrint && pages.length > 0 ? pages.length : 1) >
        deskDiv.current.offsetHeight,
    ]);
  };

  const selectTicket = (index: number, value: boolean) => {
    const tempTickets = ticketsList;
    tempTickets[index].selected = value;
    setTicketsList([...tempTickets]);
    setPages([...tempTickets.filter((e: stdObject) => e.selected)]);
  };

  const handleActive = (e: stdObject, value: boolean) => {
    const isObj = stationeryObjectCodes
      .map(({ value }) => value)
      .includes(e.partType);
    let numId = isObj
      ? e.code
      : paperData.parts.find((v: stdObject) => v.PARPAR === e.code)?.NUMPAR;

    if (emptys.includes(numId)) {
      numId = createNewPart(
        {
          PARPAR: isObj ? "" : e.code,
          TIPPAR: tabIndex === 1 ? tabIndex : e.partType,
          XPAR: 0,
          YPAR: 0,
          ANCPAR: isObj ? 100 : 0,
          ALTPAR: isObj ? 100 : 0,
          SIZPAR: 12,
          BORPAR: isObj ? 1 : 0,
          CBOPAR: colors.black,
        },
        { docValues, setDocValues },
      );
    }
    if (numId > 0) {
      const tempActives = actives;
      tempActives[numId] = value;
      setActives({ ...tempActives });
      recountRows(tempActives);
    }
    return true;
  };

  const assignItem = (num: number, changeTab: boolean) => {
    const index = paperData.parts.findIndex((e: stdObject) => e.NUMPAR === num);
    if (index > -1) {
      if (changeTab) {
        const partType = paperData.parts[index].TIPPAR;
        setTabIndex(
          partType === 1
            ? 1
            : [2, 3, 5, 13].includes(partType)
              ? 2
              : isDoc
                ? 4
                : 3,
        );
      }
      setSelected({
        ...selected,
        index,
        num,
        code: paperData.parts[index].PARPAR,
      });
    }
  };

  const recountPages = (index: number) => {
    let tempActives: stdObject = {};
    const tempParts = isPrint ? partsList[index] : parts;
    tempParts.forEach((e: stdObject) => {
      tempActives[e.NUMPAR] = true;
    });
    setActives({ ...tempActives });
    if (Array.isArray(formValues) && formValues.length > 0) {
      setInputsValues(
        formValues.reduce((acc: stdObject, curr: stdObject) => {
          return {
            ...acc,
            [curr.NUMDO1]: curr.VALDO1,
          };
        }, {}),
      );
    }
    recountRows(tempActives, partsList[index], formats[index]);
  };

  const recountRows = (
    tempActives = actives,
    tParts = paperData.parts,
    tData = paperData.data,
  ) => {
    const container = hiddenDiv.current;
    if (isDoc && (!container || Object.keys(tempActives).length === 0)) return;
    const tempPages: stdObject[] = [];

    if (container) {
      container.innerHTML = "";

      let currentPage: stdObject[] = [];

      let table = createTable({
        headerData: tParts.filter(
          (e: stdObject) => e.TIPPAR === 4 && tempActives[e.NUMPAR],
        ),
        data: tData,
        t,
      });
      let tbody = table.querySelector("tbody") as HTMLTableSectionElement;

      container.appendChild(table);

      lines.forEach((e: stdObject) => {
        const tr = document.createElement("tr");

        tParts
          .filter((e: stdObject) => e.TIPPAR === 4 && tempActives[e.NUMPAR])
          .forEach((v: stdObject) => {
            const td = document.createElement("td");
            td.textContent = e[v.PARPAR];
            td.style.padding = tData.PADDOC + "px";
            td.style.fontSize = (v.SIZPAR > 0 ? v.SIZPAR : tData.SIZDOC) + "px";
            tr.appendChild(td);
          });

        tbody.appendChild(tr);

        if (table.offsetHeight > tData.TALDOC - 20) {
          tbody.removeChild(tr);

          tempPages.push([...currentPage]);

          currentPage = [e];

          container.innerHTML = "";
          table = createTable({
            headerData: tParts.filter(
              (e: stdObject) => e.TIPPAR === 4 && tempActives[e.NUMPAR],
            ),
            data: tData,
            t,
          });
          tbody = table.querySelector("tbody") as HTMLTableSectionElement;
          container.appendChild(table);

          tbody.appendChild(tr);
        } else {
          currentPage.push(e);
        }
      });

      if (currentPage.length) {
        tempPages.push(currentPage);
      }
    }

    setPages(Array.isArray(tickets) ? tickets : tempPages);
    if (tickets) {
      setTicketsList([...tickets]);
    }
    if (showScreen) {
      setTimeout(() => setShowScreen(false), 50);
    }
  };

  useEffect(() => {
    resizePage();
  }, [scaleInfo, pages]);

  useEffect(() => {
    if (hiddenDiv.current) {
      recountPages(0);
    }
  }, [hiddenDiv.current]);

  const processTxt = (e: stdObject) => {
    switch (e.TIPPAR) {
      case 1:
        return user[e.PARPAR] ?? t(`s.${e.PARPAR}`);
      case 5:
        const rateList = area === "c" ? cPayments : vPayments;
        return rateList.find((v: stdObject) => String(v.CODTPA) === e.PARPAR)
          ?.NOMTPA;
      case 13:
        return pricesRates.find((v: stdObject) => String(v.CODTAR) === e.PARPAR)
          ?.NOMTAR;
      default:
        return !emptys.includes(e.TXTPAR)
          ? e.TXTPAR
          : !emptys.includes(e.PARPAR)
            ? t(`c.${getPrefix(e.PARPAR)}`)
            : "";
    }
  };

  return {
    t,
    type,
    mainColor,
    squareButtons,
    tabIndex,
    switchTab,
    paperData,
    getValue,
    tabs,
    fileInputRef,
    scaleInfo,
    resizeZoom,
    resizePage,
    pageDiv,
    deskDiv,
    flexDir,
    buttons,
    listItems,
    actives,
    handleActive,
    selected,
    setSelected,
    editValues,
    assignItem,
    printOptions,
    isPrint,
    isDoc,
    printData,
    pages,
    hiddenDiv,
    printArea,
    inputsValues,
    setInputsValues,
    showScreen,
    ticketsList,
    hasTicket,
    selectTicket,
    processTxt,
  };
}
